export const HOME = '/'
export const LOGIN = '/login'
export const MAINTENANCE = '/maintenance'
export const CREATE_MAGAZINE = '/create-app-magazine'
export const SETTING_USER = '/setting-user'
export const SETTING_NOTIFICATION = '/setting-notification'
export const SETTING_MAGAZINE_SUBCRIBE = '/setting-magazine-subcribe'
export const SETTING_MAGAZINE_SELL_ONCE = '/setting-magazine-sell-once'
export const SETTING_MAGAZINE_CATEGORY = '/setting-magazine-category'
export const SETTING_BANNER = '/setting-banner'
export const SETTING_SUBSCRIBER_ID = '/setting-subscriber-id'
export const SETTING_APP = '/setting-app'
